import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

Sentry.init({
  environment: import.meta.env.VITE_DEPLOYMENT_STAGE,
  dsn: 'https://0e2feef0a5852194e406ff6861218536@o4508758369959936.ingest.us.sentry.io/4508758414655488',
  beforeSend(event) {
    // Don't send events from localhost
    if (window.location.hostname === 'localhost') {
      return null;
    }
    return event;
  },
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/verantos\.com\/api\//],

  // Session Replay
  replaysSessionSampleRate: 0.0, // set to 0. Manually started for non-automation users
  replaysOnErrorSampleRate: 0.0, // set to 0. Manually started for non-automation users
});
